/* Component Dependencies */
var titleImageTemplate = require('templates/titleImage.hbs');
var AriesComponent = require('libs/aries-component');
var Popup = require('libs/popup');

AriesComponent.create({
  type: 'titleImage',
  template: {
    'titleImage': titleImageTemplate
  },
  bindEvents: function($) {
    var _self = this;
    _self.registerPopup();
			_self.$modalSelector = _self.$el.find('.js-popup');

			_self.$modalSelector.on('mfpOpen', _self.onModalOpen.bind(_self));
			_self.$modalSelector.on('mfpClose', _self.onModalClose.bind(_self));
  },

  /* This function registers Popup for the image popup */
  registerPopup: function() {
    var fullScreenPopup = new Popup({
      items: {
        src: '.l-modal-content',
        type: 'inline'
      },
      selector: '.title-image .js-popup',
      mainClass: 'mi-gallery mi-gallery-full',
      alternateCloseMarkup: true,
      fullScreen: true
    });
    fullScreenPopup.register();
  },

  onModalOpen: function() {
    var _self = this;
    _self.$el.closest('.mfp-content').addClass('l-max-width-max');
    _self.$el.addClass('is-fullscreen');

  },

  onModalClose: function() {
    var _self = this;
    _self.$el.removeClass('is-fullscreen');
  }

});
